import {gsap} from "gsap";

const animationLeave = (container) => {
    // console.log("Single Post animation LEAVE");
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power1.out",
        },
        delay:0
    });
    // si le menu de navigation mobile est ouvert, je dois le refermer avant de lancer l'animation
    // de fadeout.
    const body_el = document.body;
    const mask = container.querySelector("#project_image_mask");
    const classMenuOpened = "mobile-nav-opened";

    gsap.set(mask,{width:0});

    var delay_leave = '0';
    if(body_el.classList.contains(classMenuOpened)){
        const toggle_mobile_nav_button_el = document.querySelector("#burger-menu");
        // Create our event (with options)
        var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        toggle_mobile_nav_button_el.dispatchEvent(evt);
        delay_leave = ".3";
    }

    // document.body.classList.remove("apply-single-post")

    tl.to("#primary_section, #secondary_section", {alpha:0, y:-80, duration:.3, delay:delay_leave});
    tl.to(mask, {width:'100%',duration:1, ease: "power2.out", onComplete:() => document.body.classList.remove("apply-single-post")}, '-=.4  ')
    tl.to("#pre-footer", {duration:.3,alpha:0, y:0, ease:"power1.out"}, '-=.4')
    tl.to('body', {duration:.5,backgroundColor:'#000000'}, '-=.3');
    //tl.to(container, {alpha:0})
    //  tl.timeScale( 0.15 );
    return tl;
}

export default animationLeave;
